<template>
    <div v-if="user">
        <div class="box mt-4" v-if="$store.state.isAdmin()">
            <div class="row">
                <div class="col-sm-3">
                    <div class="form-group">
                        <label>
                            <localized-text localizedKey="Ruolo" text="Ruolo"></localized-text>
                        </label>
                        <div class="d-flex align-items-center">
                            <select class="form-control" v-model="user.role">
                                <option v-for="(item, i) in roles" :value="item">{{item}}</option>
                            </select>
                            <button class="btn btn-sm btn-danger" @click="user.role = ''">
                                x
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group">
                        <label>
                            <localized-text localizedKey="Lista" text="Lista"></localized-text>
                        </label>
                        <div class="d-flex align-items-center">
                            <select class="form-control" v-model="user.list">
                                <option v-for="item in lists" :value="item.value">{{item.value}}</option>
                            </select>
                            <button class="btn btn-sm btn-danger" @click="user.list = ''">
                                x
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <accordion class="box mt-4">
                    <template #title>
                        <localized-text class="boxTitle" localizedKey="Anagrafica" text="Anagrafica"></localized-text>
                    </template>
                    <div>
                        <personal-data v-model="user.personalData"></personal-data>
                    </div>
                </accordion>
            </div>
            <div class="col-md-6">
                <accordion class="box mt-4">
                    <template #title>
                        <localized-text class="boxTitle" localizedKey="Dati accesso" text="Dati accesso"></localized-text>
                    </template>
                    <div>
                        <auth-data :user="user" v-model="user.authData"></auth-data>
                    </div>
                </accordion>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <accordion class="box mt-4">
                    <template #title>
                        <localized-text class="boxTitle" localizedKey="Contatto" text="Contatto"></localized-text>
                    </template>
                    <div>
                        <contact-data v-model="user.contactData"></contact-data>
                    </div>
                </accordion>
            </div>
            <div class="col-md-6">
                <accordion class="box mt-4">
                    <template #title>
                        <localized-text class="boxTitle" localizedKey="Fiscali" text="Fiscali"></localized-text>
                    </template>
                    <div>
                        <fiscal-data v-model="user.fiscalData"></fiscal-data>
                    </div>
                </accordion>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <accordion class="box mt-4">
                    <template #title>
                        <localized-text class="boxTitle" localizedKey="Network" text="Network"></localized-text>
                    </template>
                    <div>
                        <network-user-selector v-model="user.networkParentNode" :userIdentifier="user.identifier" :readonly="!$store.state.isAdmin()"></network-user-selector>
                    </div>
                    <div>
                        <parent-node-history v-model="user.networkParentNodeHistory"></parent-node-history>
                    </div>
                </accordion>
            </div>
            <div class="col-md-6">
                <accordion class="box mt-4">
                    <template #title>
                        <localized-text class="boxTitle" localizedKey="Note" text="Note"></localized-text>
                    </template>
                    <div>
                        <note :user="user"></note>
                    </div>
                </accordion>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <accordion class="box mt-4">
                    <template #title>
                        <localized-text class="boxTitle" localizedKey="Qualifica" text="Qualifica"></localized-text>
                    </template>
                    <div>
                        <qualification v-model="user"></qualification>
                    </div>
                </accordion>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import { BackendRoleConfigClient, LeadClient } from '@/services/Services';
import store from '@/store';
import { ModalServices } from '@/services/ModalServices';
import { Prop } from 'vue-property-decorator';
import qualification from '@/components/user/components/qualification.vue';

@Options({
    components: {
        qualification
    }
})
export default class baseUserData extends Vue {
 
    @Prop() user: OM.Lead;
    
    lists: OM.LeadList[] = [];
    roles: string[] = [];

    created(){
        BackendRoleConfigClient.getRoles()
        .then(x => {
            this.roles = x;
        })
        LeadClient.getLists()
        .then(x => {
            this.lists = x;
        })

    }


}

</script>
